var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09725 4.24264C0.706724 3.85212 0.706721 3.21895 1.09725 2.82843C1.48777 2.43791 2.12093 2.43791 2.51145 2.82843L4.63281 4.94978L8.87548 0.707107C9.26601 0.316583 9.89917 0.316583 10.2897 0.707107C10.6802 1.09763 10.6802 1.7308 10.2897 2.12132L4.63284 7.77817L1.09725 4.24264Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.8ce80ccf74fc93c977f110224f99ec6b.svg";
export { ForwardRef as ReactComponent };